import firebase from "firebase/app";
import markdownit from "markdown-it/dist/markdown-it";

import isKnownUser from "astrid-firestore/src/api/users/utils/isKnownUser";
import { getDocumentData } from "astrid-firestore/src/helpers";

import auth from "./auth";
import db from "./db";

const markdown = markdownit({ html: true });

export function htmlMessage({ message, lang }) {
	return `<html lang="${lang}"><head></head><body>${message}</body></html>`;
}

export function markdownMessage({ message, lang }) {
	const html = markdown.render(message);

	return htmlMessage({ message: String(html), lang });
}

export default async function notify(ids, getNotificationData) {
	const uniqueIds = [...new Set(ids)].filter((id) => id !== auth.currentUser?.uid);

	if (uniqueIds.length > 0) {
		const users = await Promise.all(uniqueIds.map((id) => getDocumentData(db.collection("users").doc(id))));

		const results = await Promise.allSettled(
			users.filter(isKnownUser).map(async (user) => {
				const { slack, email, producer, notifications } = user;

				if (notifications !== "none") {
					const channel = notifications === "slack" ? "slack" : "email";

					if (channel === "slack" || email.substr(0, 6) !== "dummy-") {
						const notificationData = getNotificationData(user);

						if (notificationData?.subject && notificationData?.message) {
							const notification = {
								to: {
									uid: user.id,
									producer: producer || false,
									[channel]: channel === "slack" ? slack : email,
								},
								time: firebase.firestore.FieldValue.serverTimestamp(),
								...notificationData,
							};

							const { id } = await db.collection("notifications").add(notification);

							return id;
						}
					}
				}
			}),
		);

		return results.map(({ value }) => value);
	}
}
